import { ActionContext } from 'vuex';

type AlertActionContext = ActionContext<CheeersAlertState, CheeersRootState>;

export default {
  namespaced: true,
  state: (): CheeersAlertState => ({
    notifications: [],
    firebaseNotifications: [],
  }),
  getters: {
    notifications: (state: CheeersAlertState) => state.notifications,
    firebaseNotifications: (state: CheeersAlertState) =>
      state.firebaseNotifications,
  },
  mutations: {
    addNotification(
      state: CheeersAlertState,
      notification: CheeersNotification,
    ) {
      state.notifications = [...state.notifications, notification];
    },
    removeNotification(state: CheeersAlertState, id: number) {
      state.notifications = state.notifications.filter(
        (item) => item.id !== id,
      );
    },
    addFireBaseNotification(
      state: CheeersAlertState,
      notification: CheeersNotification,
    ) {
      state.firebaseNotifications = [
        ...state.firebaseNotifications,
        notification,
      ];
    },
    removeFirebaseNotification(state: CheeersAlertState, id: number) {
      state.firebaseNotifications = state.firebaseNotifications.filter(
        (item) => item.id !== id,
      );
    },
  },
  actions: {
    addNotification(
      { commit }: AlertActionContext,
      notification: CheeersNotification,
    ) {
      notification.id = Date.now();
      commit('addNotification', notification);
      setTimeout(() => {
        commit('removeNotification', notification.id);
      }, notification.timeout);
    },
    addFireBaseNotification(
      { commit }: AlertActionContext,
      notification: CheeersNotification,
    ) {
      notification.id = Date.now();
      commit('addFireBaseNotification', notification);
      setTimeout(() => {
        commit('removeFirebaseNotification', notification.id);
      }, notification.timeout);
    },
  },
};
